module.exports = __webpack_public_path__ + "assets/img/four.c36f03f2.png";